<template>
  <div class="app flex-row align-items-center">
    <div v-if="loading">
      <BlockUI :message="blockuimsg"></BlockUI>
    </div>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="text-white bg-primary p-4">
              <b-card-body>
                <h1>Login</h1>
                <p class="text-muted">Iniciar sesión</p>
                <b-input-group class="mb-3">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                  <input type="text" class="form-control" placeholder="Usuario" v-model="body.username" @keyup.enter="login">
                </b-input-group>
                <b-input-group class="mb-4">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                  <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="Clave" v-model="body.password" @keyup.enter="login">
                  <b-input-group-append>
                    <b-button variant="light" class="toggle-pwd-btn" @click="showPassword = !showPassword" type="button" tabindex="-1">
                      <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="light" class="btn btn-light" @click="login">Acceder</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="primary" href="#/pages/Forget">¿Perdió su contraseña?</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <b-card class="text-primary py-5 d-md-down-none text-center" style="width:44%"
                    title="Bienvenido a">
              <b-card-body class="text-center">
                <img class="navbar-brand-full" src="img/brand/logo.png" width="120" height="40" alt="Kiwa Logo">
              </b-card-body>
              <b-card-footer class="text-center">
                <img class="navbar-brand-full" src="img/brand/nunsys.png" width="110" height="37" alt="Nunsys Logo">
              </b-card-footer>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Login',
    data() {
      return {
        body: {
          username: '',
          password: ''
        },
        showPassword: false,
        rememberMe: false,
        fetchUser: false,
        error: null
      }
    },
    methods: {
      login: function () {
        var redirect = this.$auth.redirect();
        this.loading = true;
        this.$auth.login({
          body: this.body, // Vue-resource
          rememberMe: true,
          redirect: false,
          fetchUser: this.fetchUser,
          success: function (res) {
            this.loading = false;
            if (res.body && res.body.Ok) {
              this.$auth.token(null, res.body.Data.token);

              // Indico los roles
              const roles = this.getRolesAccesos(res.body.Data.User.rol_accesos, res.body.Data.User.tipo_usuario);
              res.body.Data.User.roles = roles;

              // Setea el usuario
              this.$auth.user(res.body.Data.User);

              // Seteo los roles de permisos del usuario
              localStorage.setItem('roles', JSON.stringify(roles));

              if (res.body.Data.MustChangePassword) {
                this.$toasted.show('Debe actualizar su contraseña obligatoriamente para continuar.', { theme: 'outline', type: 'info', duration: 8000 });
                this.$router.push('/pages/change');
              } else {
                var targetName = redirect ? redirect.from.name : 'Dashboard';
                this.$router.push({ name: targetName });
              }
            }
            else {
              console.log('error ' + res.body);
              this.error = res.body.Message;
            }
          },
          error: function (res) {
            this.loading = false;
            if (res.body) {
              this.$toasted.show(res.body.Message, { theme: 'outline', type: 'error', duration: 5000 });
            } else {
              this.$toasted.show('Ocurrio un error durante el login. Consulte con el Administrador del sitio.', { theme: 'outline', type: 'error', duration: 5000 });
            }
          }
        });
      }
    }
  }
</script>

<style scoped>
  .toggle-pwd-btn {
    border-color: #e4e7ea;
    background-color: #f0f3f5;
    color: #73818f;
  }
  .toggle-pwd-btn:hover {
    background-color: #e4e7ea;
    color: #2f353a;
  }
</style>
